import React from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";

import ThemeModeController from "../wrappers/Theme";

import Navbar from "../components/Navbar";
import Main from "../components/Main";
import Footer from "../components/Footer";

import Home from "./Home";
import Projects from "./Projects";
import Skills from "./Skills";
import Tools from "./Tools";
import Blog from "./Blog";
import BlogPage from "../components/Blog/BlogPage";
import ProjectsVP from "./ProjectsVP";

const styles = (theme) => ({
    // Load app bar information from the theme
    toolbar: theme.mixins.toolbar,
});

function PageList(props) {
    const { classes } = props;
    return (
        <ThemeModeController>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                }}>
                <Navbar />
                <Main>
                    {/* <div className={classes.toolbar} /> */}
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/skills" element={<Skills />} />
                        <Route path="/tools" element={<Tools />} />
                        {/* <Route path="/blog" element={<Tools />} /> */}
                        <Route path="/Todouni" />
                        <Route
                            path="/flynn-for-projects-vp"
                            element={<ProjectsVP />}
                        />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPage />} />
                        {/* <Route path='/list' element={<ListView />} /> */}

                        {/* <Route path="/blog" component={<Tools />} /> */}
                    </Routes>
                    <Footer />
                </Main>
            </Box>
        </ThemeModeController>
    );
}

export default PageList;
